import(/* webpackMode: "eager", webpackExports: ["LocalBuzzEventsExplorer"] */ "/vercel/path0/app/components/local-buzz/LocalBuzzExplorers.tsx");
